import { d as s, _ as o } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as t, createElementBlock as n, normalizeClass as l, normalizeStyle as r, createElementVNode as c } from "vue";
const a = s("issue"), i = /* @__PURE__ */ c("path", {
  d: "M512 1024C229.831 1024 0 794.169 0 512S229.831 0 512 0s512 229.831 512 512-229.831 512-512 512zm0-955.733C266.24 68.267 68.267 266.24 68.267 512S266.24 955.733 512 955.733 955.733 757.76 955.733 512 757.76 68.267 512 68.267zm31.858 377.742c18.204 0 34.133 15.929 34.133 34.133 0 2.276 0 15.93-2.275 18.205l-34.134 195.697h29.582c18.205 0 34.134 15.93 34.134 34.134s-15.93 34.133-34.134 34.133h-91.022c-18.204 0-34.133-15.929-34.133-34.133v-20.48L480.142 512H450.56c-18.204 0-34.133-15.929-34.133-34.133s15.929-34.134 34.133-34.134h93.298zm-34.134-207.076c38.685 0 68.267 29.583 68.267 68.267s-29.582 68.267-68.267 68.267-68.266-29.583-68.266-68.267 29.582-68.267 68.266-68.267z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), m = [
  i
];
function p(e, _, d, f, h, u) {
  return t(), n("svg", {
    class: l(e.classes),
    style: r(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, m, 6);
}
const w = /* @__PURE__ */ o(a, [["render", p]]);
export {
  w as default
};
